import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

Shopware.Module.register('riccardo-offer', {
    type: 'plugin',
    name: 'riccardo-offer',
    title: 'riccardo-offer.general.mainMenuItemGeneral',
    description: 'riccardo-offer.general.descriptionTextModule',
    color: '#E30613',
    icon: 'regular-megaphone',
    entity: 'riccardo_offer',

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB,
    },

    routes: {
        list: {
            component: 'riccardo-offer-list',
            path: 'list',
        },
        detail: {
            component: 'riccardo-offer-detail',
            path: 'detail/:id',
            meta: { parentPath: 'riccardo.offer.list' },
            props: { default: (route) => ({ offerId: route.params.id }) },
        },
        create: {
            component: 'riccardo-offer-detail',
            path: 'create',
            meta: { parentPath: 'riccardo.offer.list' },
        },
    },

    navigation: [{
        id: 'riccardo-offer',
        label: 'riccardo-offer.general.mainMenuItemGeneral',
        color: '#E30613',
        path: 'riccardo.offer.list',
        icon: 'regular-megaphone',
        parent: 'sw-marketing',
        position: 110,
    }],
});
